"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_FERA = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F2F9F6" },
          100: { value: "#CBE6DA" },
          200: { value: "#9DD1BA" },
          300: { value: "#65B592" },
          400: { value: "#42A57A" },
          500: { value: "#138F58" },
          600: { value: "#007944" },
          700: { value: "#006237" },
          800: { value: "#00532E" },
          900: { value: "#003C22" },
        },
        secondary: {
          50: { value: "#F6F8F1" },
          100: { value: "#DCE4C6" },
          200: { value: "#BECC94" },
          300: { value: "#98AF58" },
          400: { value: "#839E35" },
          500: { value: "#6C8622" },
          600: { value: "#5B711C" },
          700: { value: "#495B17" },
          800: { value: "#3E4D13" },
          900: { value: "#2D370E" },
        },
      },
    },
  },
});
